import React from 'react';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import ChangePasswordRequestForm from '../../components/changePasswordRequestForm/changePasswordRequestForm';
import BackButton from '../../components/backButton/backButton';

import './resetPasswordRequest.less';

const ResetPasswordRequest = () => (
  <Container className="register-page page-container">
    <BackButton to="/log-in" />
    <div className="title-wrapper">
      <Typography variant="h3">
        Zmiana hasła
      </Typography>
    </div>
    <Paper className="paper-box">
      <Container>
        <ChangePasswordRequestForm />
      </Container>
    </Paper>
  </Container>
);

export default ResetPasswordRequest;
